<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    <span>Agregar indicador</span>:
    <span>{{data.area.name}}</span>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="indicatorForm">
    <div class="form-group">
      <label for="indicatorFormPriority" class="form-label">Prioridad del indicador</label>
      <select id="indicatorFormPriority" class="form-control" formControlName="priority">
        <option value="" disabled>
          <span>Prioridad</span>
        </option>
        <option value="AAA">
          AAA
        </option>
        <option value="AA">
          AA
        </option>
        <option value="A">
          A
        </option>
      </select>
    </div>
    <p *ngIf="indicatorForm.controls['priority'].touched && indicatorForm.controls['priority'].invalid"
      class="text-danger">Este campo es requerido</p>
    <div class="form-group">
      <label for="indicatorFormIndicator" class="form-label">Indicador</label>
      <input type="text" class="form-control" id="indicatorFormIndicator" formControlName="indicator">
    </div>
    <p *ngIf="indicatorForm.controls['indicator'].touched && indicatorForm.controls['indicator'].invalid"
      class="text-danger">Este campo es requerido</p>
    <div class="form-group">
      <label for="checkType" class="form-label">Tipo de verificación</label>
      <select class="form-control" id="checkType" formControlName="checkType">
        <option value="" disabled>
          <span>Elegir tipo de verificación</span>
        </option>
        <option [ngValue]="1">
          <span>Debe ser mayor a la meta</span>
        </option>
        <option [ngValue]="2">
          <span>Debe ser menor a la meta</span>
        </option>
      </select>
    </div>
    <p *ngIf="indicatorForm.controls['checkType'].touched && indicatorForm.controls['checkType'].invalid"
      class="text-danger">Este campo es requerido</p>
    <div class="form-group">
      <label for="type" class="form-label">Tipo de dato</label>
      <select class="form-control" id="type" formControlName="type">
        <option value="" disabled>
          <span>Elegir tipo de dato a visualizar</span>
        </option>
        <option [ngValue]="1">$</option>
        <option [ngValue]="2">%</option>
        <option [ngValue]="3">#</option>
      </select>
    </div>
    <p *ngIf="indicatorForm.controls['type'].touched && indicatorForm.controls['type'].invalid" class="text-danger">
      Este campo es requerido</p>
    <div class="form-group" formGroupName="monthgoal">
      <label for="indicatorFormGoal" class="form-label">Meta</label>
      <!-- <input type="number" class="form-control" id="indicatorFormGoal" formControlName="goal"> -->
      <div class="table-responsive-dtroy mt-1">
        <table class="table align-middle  table-bordered table-sm m-0">
          <tbody>
            <td>
              <tr>Enero <input type="number" class="form-control" formControlName="Enero"></tr>
              <tr>Febrero <input type="number" class="form-control" formControlName="Febrero"></tr>
              <tr>Marzo <input type="number" class="form-control" formControlName="Marzo"></tr>
              <tr>Abril <input type="number" class="form-control" formControlName="Abril"></tr>
              <tr>Mayo <input type="number" class="form-control" formControlName="Mayo"></tr>
              <tr>Junio <input type="number" class="form-control" formControlName="Junio"></tr>
            </td>
            <td>
              <tr>Julio <input type="number" class="form-control" formControlName="Julio"></tr>
              <tr>Agosto <input type="number" class="form-control" formControlName="Agosto"></tr>
              <tr>Septiembre <input type="number" class="form-control" formControlName="Septiembre"></tr>
              <tr>Octubre <input type="number" class="form-control" formControlName="Octubre"></tr>
              <tr>Noviembre <input type="number" class="form-control" formControlName="Noviembre"></tr>
              <tr>Diciembre <input type="number" class="form-control" formControlName="Diciembre"></tr>
            </td>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <p *ngIf="indicatorForm.controls['goal'].touched && indicatorForm.controls['goal'].invalid" class="text-danger">
            Este campo es requerido</p>-->

    <div class="form-group">
      <label for="startsAt">Empieza el</label>
      <input type="date" id="startsAt" class="form-control" formControlName="startsAt" value="2022-01-01">
    </div>
    <p *ngIf="indicatorForm.controls['startsAt'].touched && indicatorForm.controls['startsAt'].invalid"
      class="text-danger">Este campo es requerido</p>
    <div class="form-group">
      <label for="endsAt">Termina el</label>
      <input type="date" id="endsAt" class="form-control" formControlName="endsAt" value="31/12/2022">
    </div>
    <p *ngIf="indicatorForm.controls['endsAt'].touched && indicatorForm.controls['endsAt'].invalid" class="text-danger">
      Este campo es requerido</p>
  </form>
</div>
<div class="modal-footer">
  <div class="btn-group w-100" role="group">
    <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="isSaving">
      <span>Cancelar</span>
    </button>
    <button type="button" class="btn btn-success" [disabled]="indicatorForm.invalid || isSaving" (click)="save()">
      <span>Guardar</span>
      <div class="spinner-border" role="status" *ngIf="isSaving">
        <span class="visually-hidden"></span>
      </div>
    </button>
  </div>
</div>
